import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
const api = new APIClient();

const path = "/auditions";
const auditionApi = {
  getAuditions(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
  getAudition(id: any, params?: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url, params);
  },
  getSummary(params?: any): Promise<any> {
    const url = `${path}/summary`;
    return api.get(url, params);
  },
  postAudition(body: any): Promise<any> {
    const url = `${path}`;
    return api.post(url, body);
  },
  putAudition(id: any, body: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.put(url, body);
  },
  patchRoleGroupAudition(body: any): Promise<any> {
    const url = `${path}/role-groups`;
    return api.patch(url, body);
  },
  postRoleGroupAudition(body: any): Promise<any> {
    const url = `${path}/role-groups`;
    return api.post(url, body);
  },
  deleteRoleGroupAudition(body: any): Promise<any> {
    const url = `${path}/role-groups`;
    return api.delete(url, { data: body });
  },
  patchRole(body: any): Promise<any> {
    const url = `${path}/roles`;
    return api.patch(url, body);
  },
  postRole(body: any): Promise<any> {
    const url = `${path}/roles`;
    return api.post(url, body);
  },
  deleteRole(body: any): Promise<any> {
    const url = `${path}/roles`;
    return api.delete(url, { data: body });
  },
};

export default auditionApi;
